// extracted by mini-css-extract-plugin
module.exports = {"container":"_2br7U","left":"_2wFJ_","right":"_3AM3w","title":"_3Lyt8","membersCount":"_1ExLr","description":"_18I3M","checkboxWrapper":"_1A3qb"};